import React, { useEffect } from 'react';
import commonStyles from '../Point.module.scss';
import Title from '../../shared/Title/Title';
import Table from './Table/Table';
import { getTranslation } from '../../../utils/translation';
import { useDispatch, useSelector } from 'react-redux';
import {
    changeIncreaseReportsPage,
    getIncreaseReports,
} from '../../../store/actions/increase-reports';
import ContentSpinner from '../../shared/Spinner/Spinner';
import Filters from './Filters/Filters';
import useOnScreen from '../../../hooks/useOnScreen';

const REPORTS_PAGE_SIZE = 20;

const Credit = () => {
    const dispatch = useDispatch();

    const { isFetching, isPaginating, currentPage, hasMore, selectedStatus, dates } = useSelector(
        state => state.increaseReports
    );

    const { ref, isIntersecting: isVisible } = useOnScreen();

    useEffect(() => {
        if (!isFetching && !isPaginating && isVisible && hasMore) {
            dispatch(changeIncreaseReportsPage(currentPage + 1));
            dispatch(getIncreaseReports(generateParams({ currentPageParam: currentPage + 1 })));
        }
    }, [isVisible, isPaginating, isFetching]);

    const generateParams = ({
        currentPageParam = currentPage,
        statusParam = selectedStatus,
        createStartDate = dates.createStartDate,
        createEndDate = dates.createEndDate,
    } = {}) => {
        const params = {};

        if (statusParam > 0) {
            params.status = statusParam;
        }

        params.createStartDate = createStartDate;
        params.createEndDate = createEndDate;
        params.offset = (currentPageParam - 1) * REPORTS_PAGE_SIZE;
        params.limit = REPORTS_PAGE_SIZE;

        return params;
    };

    return (
        <>
            <Title title={getTranslation('othersSidebarCreditLimitIncreaseReport')} />
            <Filters generateParams={generateParams} />
            <main className={commonStyles.main}>
                {isFetching && <ContentSpinner />}
                <Table />
                <button className={'v-hidden h-0'} ref={ref}>
                    Load More
                </button>
            </main>
        </>
    );
};

export default Credit;
